import { render } from "./MainSection.vue?vue&type=template&id=90045732"
const script = {}

import "./MainSection.vue?vue&type=style&index=0&id=90045732&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__